import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Stack,
  Divider,
  Container,
} from "@mui/material";
import BackBtn from "../widgets/BackBtn";
import SaveAsOutlinedIcon from "@mui/icons-material/SaveAsOutlined";
import { LoadingButton } from "@mui/lab";
import useApiEp from "../hooks/useApiEp";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../constants/constants";
import { toast } from "react-toastify";

export default function ToolsSettingsPage() {
  // fetch existing settings
  const { data, isLoading } = useApiEp(`user/product-settings`);

  const [settings, setSettings] = useState({
    transportChargePerKg: "",
    gstPercent: "",
  });

  const [saving, setSaving] = useState(false);

  // Prefill form when API data arrives
  useEffect(() => {
    if (data) {
      const s = data;

      setSettings({
        transportChargePerKg:
          s.transportChargePerKg !== undefined &&
          s.transportChargePerKg !== null
            ? String(s.transportChargePerKg)
            : "",
        gstPercent:
          s.gstPercent !== undefined && s.gstPercent !== null
            ? String(s.gstPercent)
            : "",
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // allow empty or numeric-like values (including decimals)
    if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
      setSettings((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    try {
      if (settings.transportChargePerKg === "" || settings.gstPercent === "") {
        toast.error("Please fill both Transportation Charge and GST.");
        return;
      }

      const transportNum = Number(settings.transportChargePerKg);
      const gstNum = Number(settings.gstPercent);

      if (Number.isNaN(transportNum) || Number.isNaN(gstNum)) {
        toast.error("Invalid numeric values provided.");
        return;
      }

      if (transportNum < 0 || gstNum < 0) {
        toast.error("Values cannot be negative.");
        return;
      }

      setSaving(true);

      const payload = {
        transportChargePerKg: transportNum,
        gstPercent: gstNum,
      };

      // POST /user/add-product-settings
      const response = await axios.post(
        `${API_ENDPOINT}user/add-product-settings`,
        payload,
        getHeader()
      );

      if (response?.data?.success) {
        toast.success(response.data.message || "Settings saved.");
      } else {
        toast.error(response?.data?.message || "Failed to save settings.");
      }
    } catch (err) {
      toastError(err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container sx={{ mt: 3 }} maxWidth="md">
      <BackBtn />

      <Box
        sx={{
          maxWidth: 700,
          margin: "0 auto",
          p: 3,
        }}
      >
        <Card elevation={3}>
          <CardContent>
            <Typography variant="h5" fontWeight={600} gutterBottom>
              Settings
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Stack spacing={3}>
              <TextField
                label="Transportation Charge (₹ per KG)"
                name="transportChargePerKg"
                value={settings.transportChargePerKg}
                onChange={handleChange}
                type="text"
                fullWidth
                disabled={isLoading}
                helperText="Enter numeric value. Example: 12.5"
              />

              <TextField
                label="GST (%)"
                name="gstPercent"
                value={settings.gstPercent}
                onChange={handleChange}
                type="text"
                fullWidth
                disabled={isLoading}
                helperText="GST percentage. Example: 18"
              />

              <LoadingButton
                startIcon={<SaveAsOutlinedIcon />}
                variant="contained"
                loading={saving}
                size="large"
                onClick={handleSave}
                sx={{ alignSelf: "flex-end" }}
                disabled={isLoading}
              >
                Save Settings
              </LoadingButton>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}
